import React, { useRef, useState, useEffect } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import useWindowDimensions from "../../useWindowDimensions";
import "../../styles/ScrollToTop.css"

const HorizontalScroller = ({content}) => {
  const scrollerRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);

  const scrollByAmount = (px) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: px, behavior: "smooth" });
  };

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;

    const handleScroll = () => {
      setShowLeft(el.scrollLeft > 0);
      setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
    };

    handleScroll(); // initialize state

    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, []);

  const { width } = useWindowDimensions()

  return (
    <div style={{ position: "relative", width: "100%", margin: "0 auto" }}>
      <div
        ref={scrollerRef}
        style={{
          overflowX: "auto",
          // whiteSpace: "nowrap",
          scrollBehavior: "smooth",
        }}
      >
        <div style={{ display: "inline-flex", gap: "0.5rem" }}>
          {content}
        </div>
      </div>

      {/* Left gradient + button */}
      {showLeft && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            background: "linear-gradient(to right, rgba(233,236,239,0.9), rgba(233,236,239,0))",
          }}
        >
          <button
            className="scroll-button"
            onClick={() => scrollByAmount(-0.5*width)}
            type="button"
            aria-label="Scroll left"
          >
            <HiChevronLeft size={24} />
          </button>
        </div>
      )}

      {/* Right gradient + button */}
      {showRight && (
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            height: "100%",
            width: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            background: "linear-gradient(to left, rgba(233,236,239,0.9), rgba(233,236,239,0))",
          }}
        >
        <button
          className="scroll-button"
          onClick={() => scrollByAmount(width*0.5)}
          type="button"
          aria-label="Scroll right"
        >
          <HiChevronRight size={24} />
        </button>
        </div>
      )}
    </div>
  );
};

export default HorizontalScroller;